// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.select-disabled {\n    opacity: 1 !important;\n}\n\n.item-interactive-disabled:not(.item-multiple-inputs),\n.item-interactive-disabled:not(.item-multiple-inputs) .sc-ion-label-md-h  {\n    opacity: 1 !important;\n}", ""]);
// Exports
module.exports = exports;
